const fields = [
  'PDB_Wartung_AnsprechpersonAbweichend',
  'PDB_Wartung_Ansprechperson',
  'PDB_Wartung_AnsprechpersonTelefon',
  'PDB_Wartung_AnsprechpersonEMail',
  'PDB_Wartung_IBNProtokoll',
  'PDB_Wartung_Link_IBN_Protokoll_Ordner',
  'PDB_Wartung_ProtokollSchluesseluebergabe',
  'PDB_Wartung_Link_Protokoll_Schluesseluebergabe',
  'PDB_Wartung_SchliesszylinderUVausgetauscht',
  'PDB_Wartung_AnsprechpersonSchluessel',
  'PDB_Wartung_VollstaendigeDokumentation',
  'PDB_Wartung_Link_Betrieb_Uebergabedokument_Checkliste',
  'PDB_Wartung_Gewaehrleistungsart',
  'PDB_Wartung_GewaehrleistungsartSonstige',
  'PDB_Wartung_AbnahmeProtManegelfrei',
  'PDB_Wartung_StromlaufplaeneVorhanden',
  'PDB_Wartung_Gewaehrleistung_Beginn',
  'PDB_Wartung_Gewaehrleistung_Laufzeit',
  'PDB_Wartung_Herstellergarantie',
  'PDB_Wartung_Herstellergarantie_Laufzeit',
  'PDB_Wartung_AnlageStoerungsfrei',
  'PDB_Wartung_TestladevorgangErfolg',
  'PDB_Wartung_ProjektbeschreibungVorhanden',
  'PDB_Wartung_FotoDokuVorhanden',
]

const key = 'Wartung'
export const fieldOrderWartung = {
  [key]: { fields: fields },
}

export const formGroupWartung = {
  key: key,
  title: key,
  form: key,
}
